import React, { useState, useEffect,  useCallback } from "react";
import { connect } from "react-redux";
import {
  DeleteOtherInvoicesListPayloadType,
  GetAllOtherInvoicesListPayloadType,
} from "../../../../commonTypes/invoiceGenerationTypes";
import {
  TableHeader,
  ErrorSuccessModal,
  TableLoader,
  ConfirmationModal,
} from "../../../commons";
import { OTHERS_INVOICES_LIST_HEADERS } from "../../../../constant/tableHeadersConstants/invoiceGenerationConstants/invoicesListConst";
import {
  deleteOtherInvoiceAction,
  getAllOtherInvoicesListAction,
  resetGetAllOtherInvoicesList,
  resetInvoiceGenerationError,
  resetInvoiceGenerationSuccess,
  resetOtherInvoicesTotal,
  resetSingleOtherInvoiceDetails,
  resetSuccess,
} from "../../../../redux/invoiceGeneration";
import { RootState } from "../../../../redux/rootReducers";
import AllOtherInvoicesListTableData from "./AllOtherInvoicesListTableData";
import { GetAllOtherInvoicesListType } from "../../../../redux/invoiceGeneration/invoiceGenrationTypes";
import { resetSession } from "../../../../redux/auth";
import DownloadInvoiceGenerationReports from "../../InvoiceGenerationReports";
import { SearchIcon } from "../../../Icon";
import useDebounce from "../../../../customHooks/useDebounce";
import { LoginResponseType } from "../../../../redux/auth/authTypes";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import Filter, {
  APPROVAL_RADIO_OPTIONS,
  ATTACHMENT_RADIO_OPTIONS,
  COMMENT_RADIO_OPTIONS,
  DATE_FILTER_OPTION,
} from "../../Filter.tsx/Filter";
import {
  settingApproval,
  settingAttachment,
  settingComment,
} from "../../../../utils/invoiceGeneration";
import ScrollToTop from "../../../commons/ScrollToTop";
import MultiSelect from "../../../commons/MultiSelect";
import { RadioTypes } from "../../../../commonTypes/universalTypes";
import { Col, Row } from "reactstrap";
import OtherEntiesSorting from "../../Sorting/OtherEntiesSorting";
import LockEntryModal from "../../LockEntryModal/LockEntryModal";
import toast from "react-hot-toast";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import InvoiceHistory from "../../HistoryModal/InvoiceHistory";
import {
  GetAllLedgersListPayloadType,
  GetSingleCustomerSupplierListPayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import {
  getAllTypesWithTaxListAction,
  getSingleCustomerSupplierAction,
  resetSingleCustomerSupplier,
} from "../../../../redux/clientSettings";
import ViewEditCustomerSuplierModal from "../../../Reports/LedgerStatement/ViewEditCustomerSuplierModal";
import { CustomerSupplierListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { formatDate } from "../../../../utils/commonFunctions";

type AppProps = {
  token: string | null;
  client_code: number;
  history: any;
  company_name: string;
  fetching: boolean;
  success: number | null;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  currencySign: string | undefined;
  allOthersInvoicesList: [] | GetAllOtherInvoicesListType[];
  dispatchResetInvoiceGenerationErrorAction: () => void;
  dispatchResetInvoiceGenerationSuccessAction: () => void;
  dispatchResetSession: () => void;
  dispatchResetMessageAndSuccess: () => void;
  dispatchGetAllOtherInvoicesListAction: (
    data: GetAllOtherInvoicesListPayloadType
  ) => void;
  disaptchResetSingleOtherInvoicDetails: () => void;
  dispatchDeleteOtherInvoice: (
    data: DeleteOtherInvoicesListPayloadType
  ) => void;
  loginData: LoginResponseType;
  isAddOthersPresent?: boolean;
  isEditOthersPresent?: boolean;
  isDownloadOtherReportPresent?: boolean;
  isBulkUploadOtherPresent?: boolean;
  isOthersListCommentPresent?: boolean;
  handleToggleInvoiceCommentsModal?: () => void;
  handleSetInvoiceData: (data: any) => void;
  isViewOthersInvoicePresent?: boolean;
  dispatchResetAllOtherInvoicesListAction: () => void;
  dispatchResetOtherInvoicesTotal: () => void;
  otherInvoicesTotal: string | number;
  showInvoiceCommentsModal: boolean;
  handleSubmitLockEntry: (date: string) => void;
  lockedOthersEntriesDate: null | string;
  invoiceHistoryData: any;
  invoiceHistoryOffset: number;
  isOthersHistory: boolean;
  handleLoadMore: () => void;
  invoiceHistoryCount: number;
  invoiceHistoryLimit: number;
  toggleInvoiceHistory: (type: string, id?: number) => void;
  isInvoiceHistory: boolean;
  bulkUploadFetching: boolean;
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => void;
  dispatchGetAllTypesLedgerListAction: (
    data: GetAllLedgersListPayloadType
  ) => void;
  singleCustomerSupplier: CustomerSupplierListType;
  customerSuplierFetching: boolean;
  dispatchResetSingleCustomerSupplier: () => void;
};

const AllOtherInvoicesList = ({
  token,
  client_code,
  history,
  company_name,
  fetching,
  success,
  message,
  error,
  statusCode,
  allOthersInvoicesList,
  loginData,
  isOthersListCommentPresent,
  currencySign,
  dispatchResetSession,
  dispatchGetAllOtherInvoicesListAction,
  dispatchResetInvoiceGenerationErrorAction,
  dispatchResetInvoiceGenerationSuccessAction,
  disaptchResetSingleOtherInvoicDetails,
  dispatchResetMessageAndSuccess,
  dispatchDeleteOtherInvoice,
  isEditOthersPresent,
  isAddOthersPresent,
  isDownloadOtherReportPresent,
  isBulkUploadOtherPresent,
  handleToggleInvoiceCommentsModal,
  handleSetInvoiceData,
  isViewOthersInvoicePresent,
  dispatchResetAllOtherInvoicesListAction,
  otherInvoicesTotal,
  dispatchResetOtherInvoicesTotal,
  showInvoiceCommentsModal,
  handleSubmitLockEntry,
  lockedOthersEntriesDate,
  invoiceHistoryData,
  invoiceHistoryOffset,
  isOthersHistory,
  handleLoadMore,
  invoiceHistoryCount,
  invoiceHistoryLimit,
  toggleInvoiceHistory,
  isInvoiceHistory,
  bulkUploadFetching,
  singleCustomerSupplier,
  customerSuplierFetching,
  dispatchGetSingleCustomerSupplierAction,
  dispatchGetAllTypesLedgerListAction,
  dispatchResetSingleCustomerSupplier,
}: AppProps) => {
  const persistInvoiceSearch = history?.location?.state?.searchOtherData;
  const [searchData, setSearchData] = useState(persistInvoiceSearch);
  const [remove, setRemove] = useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [deleteInvoiceId, setDeleteInvoiceId] = useState<number>(0);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<[] | GetAllOtherInvoicesListType[]>([]);
  const [searchClear, setSearchClear] = useState(false);
  const [attachment, setAttachment] = useState<string>("");
  const [approved, setApproved] = useState<string>("");
  const [clearFilter, setClearFilter] = useState<boolean>(false);
  const [multiSelectData, setMultiSelectData] = useState<any>([]);
  const [comment, setComment] = useState<string>("");
  const [commentValue, setCommentValue] = useState<string>("");
  const [approvalValue, setApprovalValue] = useState<string>("");
  const [attachmentValue, setAttachmentValue] = useState<string>("");
  const [invoiceDataValue, setInvoiceDateValue] = useState<string>("");
  const [invoiceNumberValue, setInvoiceNumberValue] = useState<string>("");
  const [invoiceNumber, setInvoiceNumber] = useState<string>("");
  const [invoiceDate, setInvoiceDate] = useState<string>("");
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
    useState<boolean>(false);
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterStartDateValue, setFilterStartDateValue] = useState("");
  const [filterEndDateValue, setFilterEndDateValue] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [filterInvoiceStartDate, setFilterInvoiceStartDate] = useState("");
  const [filterInvoiceEndDate, setFilterInvoiceEndDate] = useState("");
  const [filterInvoiceStartDateValue, setFilterInvoiceStartDateValue] =
    useState("");
  const [filterInvoiceEndDateValue, setFilterInvoiceEndDateValue] =
    useState("");
  const [radioValue, setRadioValue] = useState(DATE_FILTER_OPTION[0].id);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [redirectToCustomerSuplier, setRedirectToCustomerSuplier] =
    useState<boolean>(false);
  const [isEditCustomerSupplierPresent, setIsEditCustomerSupplierPresent] =
    useMenuCheck();
  const [isLockOtherPresent, setIsLockOtherPresent] = useMenuCheck();
  const [isDeleteOthersEntries, setIsDeleteOthersEntries] = useMenuCheck();
  const [allSorting, setAllSorting] = useState("");
  const [allSortingValue, setAllSortingValue] = useState("");
  const persistApproval = history?.location?.state?.otherApproval;
  const persistAttachment = history?.location?.state?.otherAttachement;
  const persistComment = history?.location?.state?.otherComment;
  const persistInvoiceDateOtherSorting =
    history?.location?.state?.invoiceDataOtherValue;
  const persistInvoiceNumberOtherSorting =
    history?.location?.state?.invoiceNumberOtherValue;
  const persistFilterStartDate = history?.location?.state?.otherStartDate;
  const persistFilterEndDate = history?.location?.state?.otherEndDate;
  const persistFilterRadioButton = history?.location?.state?.otherRadioValue;
  const persistFilterInvoiceStartDate =
    history?.location?.state?.otherInvoiceStartDate;
  const persistFilterInvoiceEndDate =
    history?.location?.state?.otherInvoiceEndDate;

  useEffect(() => {
    dispatchResetSingleCustomerSupplier();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      persistApproval?.length > 0 ||
      persistAttachment?.length > 0 ||
      persistComment?.length > 0 ||
      persistFilterStartDate?.length > 0 ||
      persistFilterEndDate?.length > 0 ||
      persistFilterInvoiceEndDate?.length > 0 ||
      persistFilterInvoiceStartDate?.length > 0 ||
      persistFilterRadioButton?.length > 0
    ) {
      setApproved(persistApproval);
      setAttachment(persistAttachment);
      setApprovalValue(persistApproval);
      setAttachmentValue(persistAttachment);
      setComment(persistComment);
      setCommentValue(persistComment);
      setFilterStartDateValue(persistFilterStartDate);
      setFilterStartDate(persistFilterStartDate);
      setFilterEndDateValue(persistFilterEndDate);
      setFilterEndDate(persistFilterEndDate);
      setFilterInvoiceEndDateValue(persistFilterInvoiceEndDate);
      setFilterInvoiceEndDate(persistFilterInvoiceEndDate);
      setFilterInvoiceStartDateValue(persistFilterInvoiceStartDate);
      setFilterInvoiceStartDate(persistFilterInvoiceStartDate);
      setRadioValue(persistFilterRadioButton);
    }
  }, [
    persistApproval,
    persistAttachment,
    persistComment,
    persistFilterStartDate,
    persistFilterEndDate,
    persistFilterInvoiceStartDate,
    persistFilterInvoiceEndDate,
    persistFilterRadioButton,
  ]);

  useEffect(() => {
    handleDeleteFiltersInHistory();
    setIsLockOtherPresent("Lock Other Entries", "menu");
    setIsDeleteOthersEntries("Delete Other Entries", "menu");
    setIsEditCustomerSupplierPresent("Edit Customer/Supplier", "menu");

    //
    setAllSortingValue("deafult");
    if (
      persistInvoiceDateOtherSorting === "invoice_date_asc" ||
      persistInvoiceDateOtherSorting === "invoice_date_desc"
    ) {
      setInvoiceDateValue(persistInvoiceDateOtherSorting);
      setInvoiceDate(persistInvoiceDateOtherSorting);
      setInvoiceNumberValue("");
      setInvoiceNumber("");
      setAllSortingValue(persistInvoiceDateOtherSorting);
    } else if (
      persistInvoiceNumberOtherSorting === "invoice_number_asc" ||
      persistInvoiceNumberOtherSorting === "invoice_number_desc"
    ) {
      setInvoiceNumberValue(persistInvoiceNumberOtherSorting);
      setInvoiceNumber(persistInvoiceNumberOtherSorting);
      setInvoiceDate("");
      setInvoiceDateValue("");
      setAllSortingValue(persistInvoiceNumberOtherSorting);
    } else {
      setAllSortingValue("default");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    disaptchResetSingleOtherInvoicDetails();
    dispatchResetInvoiceGenerationErrorAction();
    dispatchResetInvoiceGenerationSuccessAction();
    dispatchResetAllOtherInvoicesListAction();
    dispatchResetOtherInvoicesTotal();
    setIsMultiSelectPresent(false);
    if (remove && offset === 0) {
      if (token && client_code) {
        let finalData: GetAllOtherInvoicesListPayloadType = {
          token,
          client_code,
          limit,
          offset,
          search_value: searchData,
          attachment: attachment ? attachment : persistAttachment,
          approved: approved ? approved : persistApproval,
          invoiceDate,
          invoiceNumber,
          comment: comment ? comment : persistComment,
          created_at_start_date: filterStartDate
            ? formatDate(filterStartDate)
            : persistFilterStartDate
            ? formatDate(persistFilterStartDate)
            : "",
          created_at_end_date: filterEndDate
            ? formatDate(filterEndDate)
            : persistFilterEndDate
            ? formatDate(persistFilterEndDate)
            : "",
          invoice_date_start_date: filterInvoiceStartDate
            ? formatDate(filterInvoiceStartDate)
            : persistFilterInvoiceStartDate
            ? formatDate(persistFilterInvoiceStartDate)
            : "",
          invoice_date_end_date: filterInvoiceEndDate
            ? formatDate(filterInvoiceEndDate)
            : persistFilterInvoiceEndDate
            ? formatDate(persistFilterInvoiceEndDate)
            : "",
        };

        dispatchGetAllOtherInvoicesListAction(finalData);
      }
    } else if (offset > 0) {
      setOffset(0);
    }
    setRemove(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remove]);

  useEffect(() => {
    if (success === 1 && !!message && message === "client has been locked ") {
      fetchNewData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, message]);

  useEffect(() => {
    if (allOthersInvoicesList?.length === 0) {
      setData([...allOthersInvoicesList]);
    }
    if (offset === 0) {
      setData([...allOthersInvoicesList]);
    } else if (offset > 0) {
      setData((prv: any) => [...prv, ...allOthersInvoicesList]);
    } else {
      setData([...allOthersInvoicesList]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allOthersInvoicesList]);

  useEffect(() => {
    if (clearFilter) {
      if (token && client_code) {
        let finalData: GetAllOtherInvoicesListPayloadType = {
          token,
          client_code,
          limit,
          offset,
          search_value: searchData,
          attachment: attachment ? attachment : persistAttachment,
          approved: approved ? approved : persistApproval,
          invoiceDate,
          invoiceNumber,
          comment: comment ? comment : persistComment,
          created_at_start_date: filterStartDate
            ? formatDate(filterStartDate)
            : persistFilterStartDate
            ? formatDate(persistFilterStartDate)
            : "",
          created_at_end_date: filterEndDate
            ? formatDate(filterEndDate)
            : persistFilterEndDate
            ? formatDate(persistFilterEndDate)
            : "",
          invoice_date_start_date: filterInvoiceStartDate
            ? formatDate(filterInvoiceStartDate)
            : persistFilterInvoiceStartDate
            ? formatDate(persistFilterInvoiceStartDate)
            : "",
          invoice_date_end_date: filterInvoiceEndDate
            ? formatDate(filterInvoiceEndDate)
            : persistFilterInvoiceEndDate
            ? formatDate(persistFilterInvoiceEndDate)
            : "",
        };
        dispatchGetAllOtherInvoicesListAction(finalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFilter]);

  useEffect(() => {
    if (token && client_code && !showInvoiceCommentsModal) {
      let finalData: GetAllOtherInvoicesListPayloadType = {
        token,
        client_code,
        limit,
        offset,
        search_value: searchData,
        attachment: attachment ? attachment : persistAttachment,
        comment: comment ? comment : persistComment,
        approved: approved ? approved : persistApproval,
        invoiceDate: invoiceDate ? invoiceDate : persistInvoiceDateOtherSorting,
        invoiceNumber: invoiceNumber
          ? invoiceNumber
          : persistInvoiceNumberOtherSorting,
        created_at_start_date: filterStartDate
          ? formatDate(filterStartDate)
          : persistFilterStartDate
          ? formatDate(persistFilterStartDate)
          : "",
        created_at_end_date: filterEndDate
          ? formatDate(filterEndDate)
          : persistFilterEndDate
          ? formatDate(persistFilterEndDate)
          : "",
        invoice_date_start_date: filterInvoiceStartDate
          ? formatDate(filterInvoiceStartDate)
          : persistFilterInvoiceStartDate
          ? formatDate(persistFilterInvoiceStartDate)
          : "",
        invoice_date_end_date: filterInvoiceEndDate
          ? formatDate(filterInvoiceEndDate)
          : persistFilterInvoiceEndDate
          ? formatDate(persistFilterInvoiceEndDate)
          : "",
      };

      if (offset < +otherInvoicesTotal) {
        dispatchGetAllOtherInvoicesListAction(finalData);
      } else if (
        offset === 0 &&
        (otherInvoicesTotal === "" || +otherInvoicesTotal === 0)
      ) {
        dispatchGetAllOtherInvoicesListAction(finalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset, showInvoiceCommentsModal]);

  useEffect(() => {
    if (!showInvoiceCommentsModal) {
      window.scrollTo(0, 0);
      if (offset === 0) {
      } else {
        dispatchResetAllOtherInvoicesListAction();
        dispatchResetOtherInvoicesTotal();
        setOffset(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showInvoiceCommentsModal]);

  useEffect(() => {
    dispatchResetAllOtherInvoicesListAction();
    dispatchResetOtherInvoicesTotal();
    getData();
    setOffset(0);
    setIsMultiSelectPresent(true);
    if (
      (attachment && isMultiSelectPresent) ||
      (approved && isMultiSelectPresent) ||
      (!approved && isMultiSelectPresent) ||
      (!attachment && isMultiSelectPresent)
    ) {
      if (offset === 0) {
        let finalData: GetAllOtherInvoicesListPayloadType = {
          token,
          client_code,
          limit,
          offset,
          search_value: searchData,
          attachment: attachment ? attachment : persistAttachment,
          comment: comment ? comment : persistComment,
          approved: approved ? approved : persistApproval,
          invoiceDate: invoiceDate
            ? invoiceDate
            : persistInvoiceDateOtherSorting,
          invoiceNumber: invoiceNumber
            ? invoiceNumber
            : persistInvoiceNumberOtherSorting,
          created_at_start_date: filterStartDate
            ? formatDate(filterStartDate)
            : persistFilterStartDate
            ? formatDate(persistFilterStartDate)
            : "",
          created_at_end_date: filterEndDate
            ? formatDate(filterEndDate)
            : persistFilterEndDate
            ? formatDate(persistFilterEndDate)
            : "",
          invoice_date_start_date: filterInvoiceStartDate
            ? formatDate(filterInvoiceStartDate)
            : persistFilterInvoiceStartDate
            ? formatDate(persistFilterInvoiceStartDate)
            : "",
          invoice_date_end_date: filterInvoiceEndDate
            ? formatDate(filterInvoiceEndDate)
            : persistFilterInvoiceEndDate
            ? formatDate(persistFilterInvoiceEndDate)
            : "",
        };

        dispatchGetAllOtherInvoicesListAction(finalData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    attachment,
    approved,
    invoiceDate,
    invoiceNumber,
    comment,
    filterStartDate,
    filterEndDate,
    filterInvoiceStartDate,
    filterInvoiceEndDate,
  ]);

  const onScroll = () => {
    // if (!fetching) {

    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (
      offset < +otherInvoicesTotal &&
      !fetching &&
      Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
    ) {
      if (allOthersInvoicesList?.length > 0) {
        if (!fetching && offset < +otherInvoicesTotal) {
          setOffset(offset + limit);
        }
      }
    }
    // }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allOthersInvoicesList]);

  const handleRedirectToEditForm = (data: GetAllOtherInvoicesListType) => {
    window.scrollTo(0, 0);
    history.push({
      pathname: `/invoice-generation/edit-others/${client_code}/${data?.others_id}?type=others`,
      state: {
        client_code,
        company_name,
        attachment,
        approved,
        searchOtherData: searchData,
        invoiceDataOtherValue: invoiceDataValue,
        invoiceNumberOtherValue: invoiceNumberValue,
        comment,
        filterStartDate,
        filterEndDate,
        filterInvoiceStartDate,
        filterInvoiceEndDate,
        radioValue,
      },
    });
  };

  const handleRedirectToCopyForm = (data: GetAllOtherInvoicesListType) => {
    window.scrollTo(0, 0);
    history.push({
      pathname: `/invoice-generation/copy-others/${client_code}/${data?.others_id}?type=others`,
      state: { client_code, company_name },
    });
  };

  const handleDeleteFiltersInHistory = () => {
    delete history?.location?.state?.approval;
    delete history?.location?.state?.attachment;
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type={
              !!error &&
              error.includes(
                "Columns are not assigned to you. Please contact administrator!"
              )
                ? "warning"
                : "error"
            }
            isOpen={!!error}
            title={
              !!error &&
              error.includes(
                "Columns are not assigned to you. Please contact administrator!"
              )
                ? "Info"
                : "Error"
            }
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetInvoiceGenerationErrorAction();
            }}
          />
        );
      }
    } else {
      if (success === 1 && !!message && message === "client has been locked ") {
        dispatchResetMessageAndSuccess();
        toast.success("Entries has been locked successfully!", {
          duration: 2000,
        });
      }
    }

    return false;
  };
  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    // if (value?.length === 0) {
    //   let finalData = {
    //     offset: 0,
    //     limit,
    //     token,
    //     client_code,
    //   };

    //   dispatchGetAllOtherInvoicesListAction(finalData);
    // }
  };

  const onClose = (id: any) => {
    let newid = id.split("_")[0];

    const checkAttachmentValue = ATTACHMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?._id === id
    );
    const checkCommentValue = COMMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?._id === id
    );
    const checkApprovedValue = APPROVAL_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?._id === id
    );
    if (newid === "Att") {
      delete history?.location?.state?.otherAttachement;
    }
    if (newid === "App") {
      delete history?.location?.state?.otherApproval;
    }
    if (checkAttachmentValue) {
      setAttachment("");
      setAttachmentValue("");
    }
    if (id === "Comm") {
      delete history?.location?.state?.otherComment;
    }
    if (id === "startDate") {
      setFilterStartDate("");
      setFilterStartDateValue("");
      setFilterEndDate("");
      setFilterEndDateValue("");
      setFilterInvoiceEndDate("");
      setFilterInvoiceStartDate("");
      setFilterInvoiceEndDateValue("");
      setFilterInvoiceStartDateValue("");
      delete history?.location?.state?.otherStartDate;
      delete history?.location?.state?.otherEndDate;
      delete history?.location?.state?.otherInvoiceStartDate;
      delete history?.location?.state?.otherInvoiceEndDate;
      delete history?.location?.state?.otherRadioValue;
      setRadioValue(DATE_FILTER_OPTION[0].id);
    }

    if (checkCommentValue) {
      setComment("");
      setCommentValue("");
    }
    if (checkApprovedValue) {
      setApproved("");
      setApprovalValue("");
    }
  };

  const getData = useCallback(() => {
    const getAttachmentValue = ATTACHMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?.id === attachment
    );
    const getCommentValue = COMMENT_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?.id === comment
    );
    const getApprovedValue = APPROVAL_RADIO_OPTIONS?.find(
      (item: RadioTypes) => item?.id === approved
    );
    setMultiSelectData([
      getAttachmentValue,
      getCommentValue,
      {
        name:
          radioValue === "1"
            ? `${filterStartDate ? `Creation Date` : ""} ${
                filterStartDate ? formatDate(filterStartDate) : ""
              } ${filterStartDate ? `to` : ""} ${
                filterEndDate ? formatDate(filterEndDate) : ""
              }`
            : `${filterInvoiceStartDate ? `Invoice Date` : ""} ${
                filterInvoiceStartDate ? formatDate(filterInvoiceStartDate) : ""
              } ${filterInvoiceStartDate ? `to` : ""} ${
                filterInvoiceEndDate ? formatDate(filterInvoiceEndDate) : ""
              }`,
        _id: "startDate",
      },
      getApprovedValue,
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    attachment,
    approved,
    comment,
    filterStartDate,
    filterEndDate,
    filterInvoiceEndDate,
    filterInvoiceStartDate,
  ]);

  useEffect(() => {
    if (searchClear) {
      let finalData = {
        token,
        search_term: searchData,
        client_code,
        limit,
        offset,
        attachment: attachment ? attachment : persistAttachment,
        comment: comment ? comment : persistComment,
        approved: approved ? approved : persistApproval,
        invoiceDate: invoiceDate ? invoiceDate : persistInvoiceDateOtherSorting,
        invoiceNumber: invoiceNumber
          ? invoiceNumber
          : persistInvoiceNumberOtherSorting,
        created_at_start_date: filterStartDate
          ? formatDate(filterStartDate)
          : persistFilterStartDate
          ? formatDate(persistFilterStartDate)
          : "",
        created_at_end_date: filterEndDate
          ? formatDate(filterEndDate)
          : persistFilterEndDate
          ? formatDate(persistFilterEndDate)
          : "",
        invoice_date_start_date: filterInvoiceStartDate
          ? formatDate(filterInvoiceStartDate)
          : persistFilterInvoiceStartDate
          ? formatDate(persistFilterInvoiceStartDate)
          : "",
        invoice_date_end_date: filterInvoiceEndDate
          ? formatDate(filterInvoiceEndDate)
          : persistFilterInvoiceEndDate
          ? formatDate(persistFilterInvoiceEndDate)
          : "",
      };
      if (searchData?.length === 0) {
        dispatchResetAllOtherInvoicesListAction();
        dispatchGetAllOtherInvoicesListAction(finalData);
        setOffset(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchClear, searchData]);

  const fetchNewData = () => {
    if (token) {
      setSearchClear(true);
      let finalData = {
        token,
        client_code,
        offset: 0,
        limit,
        search_value: searchData,
        attachment: attachment ? attachment : persistAttachment,
        comment: comment ? comment : persistComment,
        approved: approved ? approved : persistApproval,
        invoiceDate: invoiceDate ? invoiceDate : persistInvoiceDateOtherSorting,
        invoiceNumber: invoiceNumber
          ? invoiceNumber
          : persistInvoiceNumberOtherSorting,
        created_at_start_date: filterStartDate
          ? formatDate(filterStartDate)
          : persistFilterStartDate
          ? formatDate(persistFilterStartDate)
          : "",
        created_at_end_date: filterEndDate
          ? formatDate(filterEndDate)
          : persistFilterEndDate
          ? formatDate(persistFilterEndDate)
          : "",
        invoice_date_start_date: filterInvoiceStartDate
          ? formatDate(filterInvoiceStartDate)
          : persistFilterInvoiceStartDate
          ? formatDate(persistFilterInvoiceStartDate)
          : "",
        invoice_date_end_date: filterInvoiceEndDate
          ? formatDate(filterInvoiceEndDate)
          : persistFilterInvoiceEndDate
          ? formatDate(persistFilterInvoiceEndDate)
          : "",
      };
      if (offset === 0) {
        setOffset(0);
        dispatchGetAllOtherInvoicesListAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const deleteOtherInvoice = (other_id: number) => {
    let data = {
      other_id,
      token,
      client_code,
    };
    // setSearchClear(false);
    // setSearchData("")
    dispatchDeleteOtherInvoice(data);
    setRemove(true);
    window.scrollTo(0, 0);
  };

  const handleShowConfirmationModal = (id: number) => {
    setShowConfirmationModal(!showConfirmationModal);
    setDeleteInvoiceId(id);
  };
  // Custom Hook for debounce function
  useDebounce(
    () => {
      if (searchData) {
        fetchNewData();
        // setPagination(PAGINATION_INITIAL);
      }
    },
    500,
    [searchData]
  );

  const handleCustomerSuppliertoggle = () => {
    setShowModal(!showModal);
    if (redirectToCustomerSuplier) {
      if (token && client_code) {
        dispatchGetAllTypesLedgerListAction({ client_code, token });
      }
    }
  };
  const handleCustomerSuplierDetailsData = (data: number) => {
    setShowModal(!showModal);
    if (token && client_code) {
      const finaldata = {
        token,
        client_code,
        customerSupplierId: data,
      };
      dispatchGetSingleCustomerSupplierAction(finaldata);
    }
  };
  return (
    <>
      <div className="col-md-12">
        <div className="row">
          <div className="col-md-4">
            <h6 style={{ margin: 0, fontSize: "18px", fontWeight: 500 }}>
              Other Entries
            </h6>
            {!fetching && (
              <span
                style={{ color: "#7c8db0", fontSize: "13px", fontWeight: 500 }}
              >
                Total {otherInvoicesTotal} entries found
              </span>
            )}
          </div>
          <div
            className="col-md-8 text-right d-flex flex-row"
            style={{ justifyContent: "flex-end" }}
          >
            <div className="mr-2 w-auto position-relative">
              <span style={{ position: "absolute", top: "8px", left: "13px" }}>
                <SearchIcon />
              </span>
              <input
                className="form-control"
                type="text"
                placeholder="Search"
                onChange={(e: any) => handleSearch(e)}
                style={{ paddingLeft: "35px" }}
                value={searchData}
              />
            </div>
         
            {isBulkUploadOtherPresent && (
              <div
                onClick={() =>
                  history.push({
                    pathname: `/invoice-generation/bulk-upload/${client_code}?type=others`,
                    state: { client_code, company_name },
                  })
                }
                className="btn btn-outline mr-2"
                style={{
                  width: "200px",
                  height: "38px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fas fa-file-upload"></i>&nbsp;Bulk&nbsp;Upload
              </div>
            )}

            <div className="ml-1">
              <Filter
                attachment={attachment}
                approved={approved}
                settingApproval={settingApproval}
                settingAttachment={settingAttachment}
                setAttachment={setAttachment}
                setApproved={setApproved}
                setClearFilter={setClearFilter}
                setOffset={setOffset}
                approvalValue={approvalValue}
                attachmentValue={attachmentValue}
                setApprovalValue={setApprovalValue}
                setAttachmentValue={setAttachmentValue}
                setData={setData}
                handleDeleteFiltersInHistory={handleDeleteFiltersInHistory}
                comment={comment}
                setComment={setComment}
                commentValue={commentValue}
                setCommentValue={setCommentValue}
                settingComment={settingComment}
                filterStartDate={filterStartDate}
                filterEndDate={filterEndDate}
                setFilterStartDate={setFilterStartDate}
                setFilterEndDate={setFilterEndDate}
                setFilterEndDateValue={setFilterEndDateValue}
                setFilterStartDateValue={setFilterStartDateValue}
                filterStartDateValue={filterStartDateValue}
                filterEndDateValue={filterEndDateValue}
                filterInvoiceStartDate={filterInvoiceStartDate}
                filterInvoiceEndDate={filterInvoiceEndDate}
                setFilterInvoiceEndDate={setFilterInvoiceEndDate}
                setFilterInvoiceStartDate={setFilterInvoiceStartDate}
                filterInvoiceStartDateValue={filterInvoiceStartDateValue}
                filterInvoiceEndDateValue={filterInvoiceEndDateValue}
                setFilterInvoiceEndDateValue={setFilterInvoiceEndDateValue}
                setFilterInvoiceStartDateValue={setFilterInvoiceStartDateValue}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
                history={history}
              />
            </div>
            <div className="ml-2">
              <OtherEntiesSorting
                invoiceDate={invoiceDate}
                setInvoiceDate={setInvoiceDate}
                invoiceNumber={invoiceNumber}
                setInvoiceNumber={setInvoiceNumber}
                invoiceDateValue={invoiceDataValue}
                setInvoiceDateValue={setInvoiceDateValue}
                invoiceNumberValue={invoiceNumberValue}
                setInvoiceNumberValue={setInvoiceNumberValue}
                allSorting={allSorting}
                setAllSorting={setAllSorting}
                allSortingValue={allSortingValue}
                setAllSortingValue={setAllSortingValue}
                history={history}
              />
            </div>

            <div className="ml-2">
              {isDownloadOtherReportPresent && (
                <DownloadInvoiceGenerationReports
                  type="others"
                  client_code={client_code}
                  token={token}
                  company_name={company_name}
                  attachment={attachment}
                  approved={approved}
                  invoiceDate={
                    invoiceDate === "invoice_date_desc"
                      ? "desc"
                      : invoiceDate === "invoice_date_asc"
                      ? "asc"
                      : ""
                  }
                  invoiceNumber={
                    invoiceNumber === "invoice_number_desc"
                      ? "desc"
                      : invoiceNumber === "invoice_number_asc"
                      ? "asc"
                      : ""
                  }
                  searchData={searchData}
                />
              )}
            </div>

            {isLockOtherPresent ? (
              <div className="ml-2">
                <LockEntryModal
                  handleSubmitLockEntry={handleSubmitLockEntry}
                  lockedEntriesDate={lockedOthersEntriesDate}
                />
              </div>
            ) : null}
          </div>

      
        </div>
        <Row>
          <Col lg={12}>
            <MultiSelect data={multiSelectData} onClose={onClose} />
          </Col>
        </Row>
      </div>
      {fetching && offset === 0 ? (
        <TableLoader Rows={10} ColumnPerRow={5} />
      ) : (
        <div className="jobsType" style={{ overflowX: "auto" }}>
          <table className="table table-bordered thead-light">
            <thead className="text-start sticky-table-header">
              <TableHeader
                tableHeader={OTHERS_INVOICES_LIST_HEADERS}
                extraHeader
              />
            </thead>
            <tbody>
              <AllOtherInvoicesListTableData
                data={data}
                tableHeader={OTHERS_INVOICES_LIST_HEADERS}
                handleRedirectToEditForm={handleRedirectToEditForm}
                handleRedirectToCopyForm={handleRedirectToCopyForm}
                handleShowConfirmationModal={handleShowConfirmationModal}
                client_code={client_code}
                deleteOtherInvoice={deleteOtherInvoice}
                loginData={loginData}
                isAddOthersPresent={isAddOthersPresent}
                isEditOthersPresent={isEditOthersPresent}
                handleToggleInvoiceCommentsModal={
                  handleToggleInvoiceCommentsModal
                }
                handleSetInvoiceData={handleSetInvoiceData}
                isViewOthersInvoicePresent={isViewOthersInvoicePresent}
                isOthersListCommentPresent={isOthersListCommentPresent}
                currencySign={currencySign}
                lockedOthersEntriesDate={lockedOthersEntriesDate}
                isDeleteOthersEntries={isDeleteOthersEntries}
                toggleInvoiceHistory={toggleInvoiceHistory}
                isOthersHistory={isOthersHistory}
                handleCustomerSuplierDetailsData={
                  handleCustomerSuplierDetailsData
                }
              />
              <ScrollToTop />
              {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
            </tbody>
          </table>
        </div>
      )}
      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleShowConfirmationModal(deleteInvoiceId);
          }}
          isOpen={showConfirmationModal}
          title={"Delete Other Entry"}
          message={`Are you sure you want to Delete`}
          confirmButtonText={"Delete"}
          onPressConfirm={() => {
            deleteOtherInvoice(deleteInvoiceId);
            handleShowConfirmationModal(deleteInvoiceId);
          }}
        />
      )}

      {
        <InvoiceHistory
          isRight={true}
          isOpen={isInvoiceHistory}
          onClose={toggleInvoiceHistory}
          history={invoiceHistoryData}
          clientCode={client_code}
          fetching={bulkUploadFetching}
          handleLoadMore={handleLoadMore}
          invoiceHistoryLimit={invoiceHistoryLimit}
          invoiceHistoryCount={invoiceHistoryCount}
          invoiceHistoryOffset={invoiceHistoryOffset}
        />
      }
      {showModal && (
        <ViewEditCustomerSuplierModal
          isOpen={showModal}
          setRedirectToCustomerSuplier={setRedirectToCustomerSuplier}
          fetching={customerSuplierFetching}
          client_code={client_code}
          company_name={company_name}
          isEditCustomerSupplierPresent={isEditCustomerSupplierPresent}
          toggle={handleCustomerSuppliertoggle}
          singleCustomerSupplier={singleCustomerSupplier}
          currencySign={currencySign}
        />
      )}

      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  message: state.invoiceGeneration.message,
  allOthersInvoicesList: state.invoiceGeneration.allOtherInvoicesList,
  statusCode: state.invoiceGeneration.statusCode,
  error: state.invoiceGeneration.error,
  otherInvoicesTotal: state.invoiceGeneration.otherInvoicesTotal,
  lockedOthersEntriesDate: state.invoiceGeneration.lockOthersEntriesDate,
  bulkUploadFetching: state.invoiceGeneration.bulkUploadFetching,
  singleCustomerSupplier: state.clientSettings.singleCustomerSupplier,
  customerSuplierFetching: state.clientSettings.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetAllOtherInvoicesListAction: () =>
    dispatch(resetGetAllOtherInvoicesList()),
  dispatchGetAllOtherInvoicesListAction: (
    data: GetAllOtherInvoicesListPayloadType
  ) => dispatch(getAllOtherInvoicesListAction(data)),
  dispatchResetInvoiceGenerationErrorAction: () =>
    dispatch(resetInvoiceGenerationError()),
  dispatchResetInvoiceGenerationSuccessAction: () =>
    dispatch(resetInvoiceGenerationSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetOtherInvoicesTotal: () => dispatch(resetOtherInvoicesTotal()),
  dispatchResetMessageAndSuccess: () => dispatch(resetSuccess()),
  disaptchResetSingleOtherInvoicDetails: () =>
    dispatch(resetSingleOtherInvoiceDetails()),
  dispatchDeleteOtherInvoice: (data: DeleteOtherInvoicesListPayloadType) =>
    dispatch(deleteOtherInvoiceAction(data)),
  dispatchGetSingleCustomerSupplierAction: (
    data: GetSingleCustomerSupplierListPayloadType
  ) => dispatch(getSingleCustomerSupplierAction(data)),
  dispatchGetAllTypesLedgerListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllTypesWithTaxListAction(data)),
  dispatchResetSingleCustomerSupplier: () =>
    dispatch(resetSingleCustomerSupplier()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllOtherInvoicesList);
